import { z } from "zod";

import { ExclusionReasonCountSchema } from "./exclusion-reason-counts";

/**
 * The lead counts the lean list payload carries, spread into `ListSchema`.
 *
 * Extracted from `list.ts` while working on PREC-4094 — that file is well over the 500-line
 * ceiling, so anything added to it has to pay for itself. They belong together anyway: every one of
 * them is a SQL aggregate, which the API returns as a **string** at runtime whatever the type says,
 * so anything summed here has to be coerced before arithmetic (web CLAUDE.md §6).
 *
 * Note there is no count for leads the list refused as already-on-another-list: they are not
 * surfaced in the list view at all (PREC-4094), so the web never asks for that number.
 */
export const ListCountsSchema = z.object({
	draftCount: z.number().optional(),
	maybeCount: z.number().optional(),
	excludedCount: z.number().optional(),
	manuallyExcludedCount: z.number().optional(),
	blacklistCount: z.number().optional(),
	/** Per-(bucket, reason) counts for the grouped Show filter's sub-rows (PREC-3536 Phase 5). */
	exclusionReasonCounts: z.array(ExclusionReasonCountSchema).optional(),
	underReviewCount: z.number().optional(),
	trackerOrganizationCount: z.coerce.number().optional(),
	archivedCount: z.number().optional(),
	doneCount: z.number().optional(),
	assignedCount: z.number().optional(),
	savedForLaterCount: z.number().optional(),
	trackedProfileCount: z.number().optional(),
	/** Companies on a company-only list's Companies tab (PREC-4400); a string at runtime. */
	companiesCount: z.coerce.number().optional(),
});
